import type { ExtrudeGeometry, Mesh, MeshStandardMaterial } from 'three';

/**
 * Get actual quality level (handles negative values for debug mode)
 */
export const getActualQuality = (renderQuality: number): number => {
	return renderQuality === 0 ? 0 : Math.abs(renderQuality);
};

/**
 * Apply quality-based geometry optimizations
 */
export const applyGeometryQualityOptimizations = (
	geometry: ExtrudeGeometry,
	actualQuality: number
): void => {
	if (actualQuality <= 3) {
		if (actualQuality > 0) {
			geometry.computeVertexNormals();
		}
		if (geometry.attributes.tangent) {
			geometry.deleteAttribute('tangent');
		}
		if (actualQuality === 0 && geometry.attributes.uv) {
			geometry.deleteAttribute('uv');
		}
	} else {
		geometry.computeVertexNormals();
		geometry.normalizeNormals();
	}
};

/**
 * Apply quality-based optimizations to model
 */
export const applyModelQualityOptimizations = (
	mesh: Mesh,
	actualQuality: number
): void => {
	if (actualQuality <= 3 && mesh.geometry) {
		const geom = mesh.geometry;
		if (actualQuality === 0) {
			geom.deleteAttribute('uv');
			geom.deleteAttribute('normal');
		}
		if (geom.attributes.tangent) {
			geom.deleteAttribute('tangent');
		}
		if (geom.attributes.color) {
			geom.deleteAttribute('color');
		}
	}
};

/**
 * Apply low quality material optimizations
 */
export const applyLowQualityMaterialOptimizations = (
	mat: MeshStandardMaterial,
	actualQuality: number
): void => {
	mat.roughnessMap = null;
	mat.metalnessMap = null;
	mat.aoMap = null;
	if (actualQuality === 0) {
		mat.map = null;
	}
	mat.needsUpdate = true;
};
